import { render, staticRenderFns } from "./PostPreviewModal.vue?vue&type=template&id=1c9f006a&scoped=true"
import script from "./PostPreviewModal.vue?vue&type=script&lang=js"
export * from "./PostPreviewModal.vue?vue&type=script&lang=js"
import style0 from "./PostPreviewModal.vue?vue&type=style&index=0&id=1c9f006a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c9f006a",
  null
  
)

export default component.exports